(() => {
  if (window.skyCupQuoteContextReady) return;
  window.skyCupQuoteContextReady = true;
  const updateQuote = (link) => {
    let url;
    try { url = new URL(link.getAttribute('href'), window.location.origin); } catch { return; }
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/pages/')) return;
    const root = link.closest('product-info') || link.closest('[id^="MainProduct-"]');
    const form = document.getElementById(link.dataset.productForm);
    url.searchParams.set('sky_product', link.dataset.productHandle);
    url.searchParams.set('sky_title', link.dataset.productTitle);
    const variant = form?.querySelector('[name="id"]')?.value;
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('sky_variant', variant);
    const quantity = root?.querySelector('input[name="quantity"]')?.value;
    if (quantity && /^\d+$/.test(quantity)) url.searchParams.set('sky_quantity', quantity);
    const selected = root ? Array.from(root.querySelectorAll('variant-selects input:checked, variant-selects select')).map(input => input.selectedOptions ? input.selectedOptions[0]?.textContent.trim() : input.value).filter(Boolean) : [];
    if (selected.length) url.searchParams.set('sky_options', selected.join(' / '));
    link.href = url.href;
  };
  document.addEventListener('pointerdown', event => {
    const link = event.target.closest?.('a[data-sky-cup-quote]');
    if (link) updateQuote(link);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-sky-cup-quote]');
    if (link) updateQuote(link);
  });
})();
